import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, reset } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
// Style
import {
  FormGroup,
  Col,
  FormControl,
  Container,
  Row,
  Form
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import Link from '../../Link';
import Loader from '../../Common/Loader';
import GooglePolygonMap from '../../Common/GooglePolygonMap';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import bt from '../../../components/commonStyle.css';
import s from './ManageLocation.css';


class ManageLocationForm extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
  }
  static defaultProps = {
    loading: false
  };

  handlePlaceChanged() {
    const place = this.autocomplete.getPlace();
    this.props.onPlaceLoaded(place);
  }

  render() {
    const { error, handleSubmit, submitting, loading, isEditForm, initialValues, updateLoading } = this.props;
    const { formatMessage } = this.props.intl;
    const isActiveOption = [
      { value: 1, label: formatMessage(messages.active) },
      { value: 0, label: formatMessage(messages.inactive) }
    ]
    return (
      <div className={cx(s.pagecontentWrapper, 'mapSection')}>
        <Container className={s.containerWith}>
          <div className={s.contentBox}>
            <h1 className='siteAdminPrimaryHeading'>{formatMessage(isEditForm ? messages.editLocation : messages.addLocation)}</h1>
            <Form onSubmit={handleSubmit(submit)} >
              {error && <strong>{error}</strong>}
              <div className='twoColumnGrid'>
                <Field
                  name="locationName"
                  type="text"
                  component={InputFieldComponent}
                  label={formatMessage(messages.nameOnly)}
                  inputClass={bt.formControlInput}
                />

                {isEditForm &&
                  <Field
                    name="isActive"
                    label={formatMessage(messages.status)}
                    component={SelectFieldComponent}
                    options={isActiveOption}
                    inputClass={bt.formControlSelect}
                  />
                }

                <Field
                  name="description"
                  type="text"
                  placeholder={formatMessage(messages.description)}
                  component={InputFieldComponent}
                  componentClass="textarea"
                  label={formatMessage(messages.description)}
                  inputClass={bt.formTextArea}
                />
              </div>
              <div className={cx(s.searchLocation, "locationSearchMapContainer")}>
                {isEditForm && initialValues?.path ?
                  <GooglePolygonMap
                    formName={'ManageLocationForm'}
                    fieldName={'path'}
                    paths={initialValues?.path}
                    containerClassName='locationGeoSuggestContainer'
                  /> :
                  <GooglePolygonMap
                    formName={'ManageLocationForm'}
                    fieldName={'path'}
                    containerClassName='locationGeoSuggestContainer'
                  />
                }
              </div>

              <div className='commonButtonContainer'>
                <Link to={"/siteadmin/location"} className={cx(s.backBtn, bt.btnSecondary, s.displayInlineBlock)} >{formatMessage(messages.goBack)}</Link>
                <Loader
                  type={"button"}
                  label={formatMessage(messages.submitButton)}
                  show={loading || updateLoading}
                  buttonType={'submit'}
                  className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                  disabled={submitting || loading || updateLoading}
                />
              </div>
            </Form>
          </div>
        </Container>
      </div>
    );
  }
}
ManageLocationForm = reduxForm({
  form: 'ManageLocationForm',
  onSubmit: submit,
  validate
})(ManageLocationForm);

const mapState = (state) => ({
  loading: state.loader.AddLocation,
  updateLoading: state.loader.updateLocation
});
const mapDispatch = {};
export default injectIntl(compose(
  withStyles(bt, s),
  connect(mapState, mapDispatch)
)(ManageLocationForm));
